/**
 * @generated SignedSource<<b1a292011b671e392174aac956a66d8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type CommentAuthorAssociation = "COLLABORATOR" | "CONTRIBUTOR" | "FIRST_TIMER" | "FIRST_TIME_CONTRIBUTOR" | "MANNEQUIN" | "MEMBER" | "NONE" | "OWNER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useFetchCommitThreadCommitComment$data = {
  readonly author: {
    readonly avatarUrl: string;
    readonly id: string;
    readonly login: string;
    readonly url: string;
  } | null | undefined;
  readonly authorAssociation: CommentAuthorAssociation;
  readonly body: string;
  readonly bodyHTML: string;
  readonly createdAt: string;
  readonly databaseId: number | null | undefined;
  readonly id: string;
  readonly isHidden: boolean;
  readonly lastUserContentEdit: {
    readonly editor: {
      readonly login: string;
      readonly url: string;
    } | null | undefined;
  } | null | undefined;
  readonly minimizedReason: string | null | undefined;
  readonly publishedAt: string | null | undefined;
  readonly reference: {
    readonly author: {
      readonly user: {
        readonly login: string;
      } | null | undefined;
    } | null | undefined;
    readonly text: string;
  } | null | undefined;
  readonly repository: {
    readonly id: string;
    readonly isPrivate: boolean;
    readonly name: string;
    readonly owner: {
      readonly id: string;
      readonly login: string;
      readonly url: string;
    };
  };
  readonly stafftoolsUrl: string | null | undefined;
  readonly url: string;
  readonly viewerCanBlockFromOrg: boolean;
  readonly viewerCanDelete: boolean;
  readonly viewerCanMinimize: boolean;
  readonly viewerCanReport: boolean;
  readonly viewerCanReportToMaintainer: boolean;
  readonly viewerCanSeeMinimizeButton: boolean;
  readonly viewerCanSeeUnminimizeButton: boolean;
  readonly viewerCanUnblockFromOrg: boolean;
  readonly viewerCanUpdate: boolean;
  readonly viewerDidAuthor: boolean;
  readonly viewerRelationship: CommentAuthorAssociation;
  readonly " $fragmentSpreads": FragmentRefs<"MarkdownEditHistoryViewer_comment" | "ReactionViewerGroups">;
  readonly " $fragmentType": "useFetchCommitThreadCommitComment";
};
export type useFetchCommitThreadCommitComment$key = {
  readonly " $data"?: useFetchCommitThreadCommitComment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFetchCommitThreadCommitComment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useFetchCommitThreadCommitComment"
};

(node as any).hash = "1ae58e39387fb525a2e2cbc71008f683";

export default node;
